import { common } from "helpers";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
// includes
import AgTable from "elements/AgTable";

function List() {
  // init
  const navigate = useNavigate();
  const { id } = useParams();
  // state
  const [permission] = useState(common.getUserPermission());
  // effect
  useEffect(() => {
    if (!permission.includes("mer")) {
      navigate("/profile");
    }
  }, []);
  // function
  const callAction = (data) => {
    if (data.type == "View") {
      navigate("/member/view/" + data.item._id);
    }
  };

  return (
    permission.includes("mer") && (
      <AgTable
        module="adminSubAgent"
        filterData={{
          agentSingle: { key: "agentId", value: "" },
          status: { key: "isActive", value: "" },
          dateA: { key: "startDate", value: "", title: "Created Date From" },
          dateB: { key: "endDate", value: "", title: "Created Date To" },
        }}
        onAction={(data) => callAction(data)}
        actionPermission={common.accessTable(permission, [
          "mec",
          "meu",
          "mer",
          "med",
        ])}
      />
    )
  );
}

export default List;
